import React, { Component } from "react";
import axios from "axios";
import * as appConst from "../../../Common/constants";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import downloadImage from "../../../Images/download.jpg"
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import fileDownload from 'js-file-download';
import { SelectButton } from "primereact/selectbutton";
import { Growl } from "primereact/growl";

class Extract extends Component {
  constructor(props) {
    super(props);
    this.state =
    {
      inputFiles: null,
      outputFiles: null,
      account: "NA"
    };
  }

  componentDidMount() {

  }

  LoadFiles(account) {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/file?mode=FK&account=" + account
      )
      .then(response => {
        this.setState({
          inputFiles: response.data.InputFiles,
          outputFiles: response.data.OutputFiles
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {

    const accounts = [
      { label: "EBuy", value: "EBuy" },
      { label: "Nehr", value: "Nehr" }
    ];


    return (
      <div>
        <h3 align="center">Flipkart - Order Extract</h3>
        <div className="container-fluid">

          <div className="row p-1 border">
            <div className="col col-md-2">Select Account</div>
            <div className="col col-md-3">
              <SelectButton
                value={this.state.account}
                options={accounts}
                onChange={this.onAccountChange}
                className="p-error"
              />
            </div>
            <div className="col col-md-1"></div>
            <div className="col col-md-6">
              <input type="file" onChange={this.fileChangedHandler} />
              <button
                onClick={this.uploadHandler}
                className="btn btn-primary btn-sm"
              >
                Upload
              </button>
            </div>
          </div>
          <div className="row p-1 border text-center">
            <button
              onClick={this.processClick}
              className="btn btn-warning btn-lg"
            >
              Process
            </button>
          </div>
          <div className="row p-1 border">
            <div className="ag-theme-blue" style={{ height: "300px" }}>
              <div>
                <button
                  onClick={this.onDeleteInputClick}
                  className="btn btn-primary btn-sm mb-2 mr-2"
                >
                  Clear Input Files
                </button>
              </div>
              <AgGridReact
                rowData={this.state.inputFiles}
                pagination={true}
                enableSorting={true}
                enableFilter={true}
                onGridReady={params => (this.gridApi = params.api)}
                paginationAutoPageSize={true}
              >
                <AgGridColumn
                  field="Name"
                  headerName="Input File"
                  width={350}
                  sortable
                  resizable
                  filter
                />
              </AgGridReact></div>&nbsp;
            <div className="ag-theme-blue" style={{ height: "300px" }}>
              <div>
                <button
                  onClick={this.onDeleteOutputClick}
                  className="btn btn-primary btn-sm mb-2 mr-2"
                >
                  Clear Output Files
                </button>
              </div>
              <AgGridReact
                rowData={this.state.outputFiles}
                pagination={true}
                enableSorting={true}
                enableFilter={true}
                onGridReady={params => (this.gridApi = params.api)}
                paginationAutoPageSize={true}
              >
                <AgGridColumn
                  width={40}
                  cellRendererFramework={this.renderDownloadButton}
                />
                <AgGridColumn
                  field="Name"
                  headerName="Output File"
                  width={350}
                  sortable
                  resizable
                  filter
                />

              </AgGridReact></div>
          </div>
        </div>
        <Growl ref={el => (this.growl = el)} />
      </div>
    );
  }

  onAccountChange = e => {
    this.setState({ account: e.value });
    if (e.value !== "") {
      this.LoadFiles(e.value);
    }
    else {
      this.setState({ inputFiles: null, outputFiles: null });
    }
  };

  renderDownloadButton = params => {
    return (
      <p>
        <a
          onClick={this.onDownloadClick}
        >
          <img src={downloadImage} name={params.data.Name} width="20px" height="20px" />
        </a>
      </p>
    );
  };

  onDownloadClick = e => {
    var name = e.target.getAttribute("name");
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/outputfile?mode=FK&account=" + this.state.account + "&fileName=" + name
      )
      .then(res => {
        fileDownload(res.data.Content, res.data.FileName)
      });
  };

  fileChangedHandler = event => {
    this.setState({ selectedFile: event.target.files[0] })
  }

  uploadHandler = () => {
    if (this.state.selectedFile !== null &&
      this.state.account !== "NA" &&
      this.state.account !== null) {
      const formData = new FormData();
      formData.append(
        'file',
        this.state.selectedFile,
        this.state.selectedFile.name,
      )

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/file?mode=FK&account=" + this.state.account,
          formData
        )
        .then(res => {
          this.setState({ selectedFile: null });
          this.LoadFiles(this.state.account);
        });
    }
    else {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Account !!"
      });
    }
  }

  processClick = () => {
    if (this.state.account !== "NA" && this.state.account !== null) {
      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/file/process?mode=FK&account=" + this.state.account
        )
        .then(res => {
          if (res.status === 200) {
            this.LoadFiles(this.state.account);
          } else if (res.status === 204) {
            this.growl.show({
              severity: "error",
              summary: "Error !!",
              detail: "Invalid File Format !!"
            });
          }
        });
    }
    else {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Account !!"
      });
    }
  }

  onDeleteInputClick = () => {
    this.DeleteFiles("input");
  }

  onDeleteOutputClick = () => {
    this.DeleteFiles("output");
  }

  DeleteFiles(type) {
    var res = window.confirm("Are you sure to delete ?");
    if (res == true) {
      axios
        .delete(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/file?mode=FK&account=" + this.state.account + "&type=" + type
        )
        .then(res => {
          this.LoadFiles(this.state.account);
        });
    }
  }
}

export default Extract;
